export default __webpack_public_path__ + "static/media/shutterstock_1077839366_estudiantes_1.1506dffc.webp";